/* jshint browserify: true */
/* global MathJax */
'use strict';

import $ from 'jquery';
import Renderer from './renderer';

const files = { mainjs: '//cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.0/MathJax.js?config=TeX-AMS_HTML' };

let loadPromise;

export default class MathJaxRenderer extends Renderer {
    constructor() {
        super();
        this.elementClassName = 'math-formula-mathjax';
    }

    render(elements) {
        const d = $.Deferred(),
            $elements = $(elements),
            $scripts = $elements.find('script');

        elements = ($scripts.length === 1) ? $scripts[0] : $scripts.toArray();

        loadMathJax().done(() => {
            MathJax.Hub.Queue(
                ['Typeset', MathJax.Hub, elements],
                () => { d.resolve($elements); }
            );
        });

        return d;
    }

    update(element) {
        const $element = $(element).first(),
            elementToMoveSelector = '> .MathJax_Display, > .MathJax, > script',
            $buffer = $('<div>').insertAfter($element.parent()).css('visibility', 'hidden');

        $buffer.css({ left: 0 });

        this._createScriptElement(element).appendTo($buffer);

        return this.render($buffer).done(() => {
            const $result = $(elementToMoveSelector, $buffer);
            $(elementToMoveSelector, $element).remove();
            $result.appendTo($element);
            $buffer.remove();
        });
    }

    elementsPreProcessor(elements) {
        $(elements).each((n, mathElement) => {
            const $mathElement = $(mathElement),
                content = $mathElement.text();

            $mathElement.empty();

            $('<span>')
                .addClass('MathJax_Preview')
                .text(content)
                .appendTo(mathElement);

            this._createScriptElement(mathElement).appendTo(mathElement);
        });
    }

    _createScriptElement(mathElement) {
        const $script = $('<script>'),
            math = this.getMathFromElement(mathElement) || {};

        let type = 'math/tex';

        if (!math.inline) {
            type += '; mode=display';
        }

        $script.attr('type', type).html(math.latex);

        return $script;
    }
}

function loadMathJax() {
    if (!loadPromise) {
        loadPromise = $.ajax({
            dataType: 'script',
            cache: true,
            url: files.mainjs,
        }).done(function () {
            MathJax.Hub.Config({
                showMathMenu: false,
                jax: ['input/TeX','output/HTML-CSS', 'output/CommonHTML'],
                extensions: [],
                TeX: {
                    extensions: ['color.js', 'AMSmath.js','AMSsymbols.js','noErrors.js','noUndefined.js'],
                },
            });
        });
    }

    return loadPromise;
}
